import { XMarkIcon } from "@heroicons/react/24/outline";
import Input from "src/components/Inputs/Input";
import Modal from "src/components/Modal";
import { useInfo } from "src/hooks/useData";
import YearlyIncreaseComponent from "../YearlyIncrease";
import { NewSpending } from "src/types";
import StartEndSelect from "src/components/Info/StartEndSelect";

const NewSpendingModal = ({
  open,
  index,
  setOpen,
  settings,
}: {
  open: boolean;
  index: number;
  setOpen: any;
  settings: any;
}) => {
  const { data, setField } = useInfo();
  const spending = data.spending;
  const setPostSpending = (
    index: number,
    field: keyof NewSpending,
    value: NewSpending[typeof field],
  ) => {
    setField("spending")({
      ...spending,
      postSpending: spending.postSpending.map((item, i) =>
        index === i ? { ...item, [field]: value } : item,
      ),
    });
  };
  const line = spending.postSpending[index];

  return (
    <>
      <Modal
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="flex justify-between mb-5">
          <div className="text-lg font-semibold w-96 text-left">
            New Spending — {line.category}
            <div className="text-sm font-normal italic text-gray-500 mt-1">
              These changes will affect Spending for ALL scenarios
            </div>
          </div>
          <XMarkIcon
            className="h-6 w-6 cursor-pointer"
            onClick={() => setOpen(false)}
          />
        </div>

        <div className="flex justify-between">
          <div className="flex flex-col gap-4 w-full text-left">
            <td className="">
              <Input
                value={line.category}
                setValue={(v) => setPostSpending(index, "category", v)}
                size="full"
                subtype="text"
                label={"Category"}
              />
            </td>
            <td className="">
              <Input
                label={
                  <div>
                    Amount
                    <div className="text-xs">(Today's Dollars)</div>
                  </div>
                }
                size="full"
                width="w-[259px]!"
                value={
                  line.newAmount
                    ? line.newAmount
                    : { type: "yearly", value: line.amount }
                }
                setValue={(v) => setPostSpending(index, "newAmount", v)}
                subtype="mo/yr"
              />
            </td>
            <td className="">
              <StartEndSelect
                value={line.startYear}
                setValue={(v) => setPostSpending(index, "startYear", v)}
                shownOptions={[
                  ["calendar-year"],
                  ["#-of-years"],
                  ...(data.people.map((p) => [
                    "retirement" as const,
                    p.id,
                  ]) as any),
                  ...(data.people.map((p) => ["age" as const, p.id]) as any),
                  ...(data.people.map((p) => ["death" as const, p.id]) as any),
                ]}
                settings={settings}
                label="Starts"
              />
            </td>
            <td className="">
              <StartEndSelect
                value={line.endYear}
                setValue={(v) => setPostSpending(index, "endYear", v)}
                shownOptions={[
                  ["calendar-year"],
                  ["#-of-years"],
                  ...(data.people.map((p) => [
                    "retirement" as const,
                    p.id,
                  ]) as any),
                  ...(data.people.map((p) => ["age" as const, p.id]) as any),
                  ...(data.people.map((p) => ["death" as const, p.id]) as any),
                ]}
                settings={settings}
                label="Ends"
              />
            </td>
            <td className="flex items-center text-sm ">
              <div className="w-[148px] text-[#344054]">Yearly Increase</div>
              <YearlyIncreaseComponent
                labels={false}
                vertical={false}
                increase={line.increase}
                setYearlyIncrease={(v) => setPostSpending(index, "increase", v)}
              />
            </td>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NewSpendingModal;
